import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { addToCart } from "../store/slices/CartSlice";
import { RiShoppingCartLine } from "react-icons/ri";
import { FaEye, FaRegHeart } from "react-icons/fa";
import { FaCodeCompare } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import { getALLCategory } from "../apis/config";
import { products } from "../data/products";
import { addToComapre } from "../store/slices/CompareSlice";
import { addToWish, removeFromWish } from "../store/slices/WishSlice";
import toast from "react-hot-toast";

const WishCard = ({ data,rt }) => {
  const [added,setAdded] = useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [categorys, setCategorys] = useState([]);

  useEffect(() => {
    getALLCategory()
      .then((res) => setCategorys(res.data))
      .catch((err) => console.log(err));
  }, []);

  const handleAddProduct = (product) => {
    dispatch(addToCart({ ...product, quantity: 1 }));
    setAdded(true)
    toast.success( `${product.name} added to your cart`)
  };

  const handleToCompare = (product)=>{
    dispatch(addToComapre(product))
    toast.success( `${product.name} added to compare`)
  }

  const handleToWish = (product)=>{
    dispatch(removeFromWish(product))
    toast.success( `${product.name} removed successfully`)
  }

  
const [currentImageIndex, setCurrentImageIndex] = useState(0);
const [isHovered, setIsHovered] = useState(false);
const intervalRef = useRef(null);

const startAutoSlide = () => {
  if (intervalRef.current) return;
  setIsHovered(true);
  intervalRef.current = setInterval(() => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % data.images.length);
  }, 1000);
};

const stopAutoSlide = () => {
  clearInterval(intervalRef.current);
  intervalRef.current = null;
  setCurrentImageIndex(0);
  setIsHovered(false);
};

const currentImage = data.images[currentImageIndex];

  return (
    <div
      //   key={index}
      className={`flex min-w-[180px] sm:w-[270px] ${rt ? " mx-auto md:mx-0" :"mx-auto"} flex-col justify-center shadow hover:shadow-md hover:scale-105 transition-all`}
    >
      <div className=" rounded-md relative flex flex-col justify-center items-center ">
        {/* <Link to={`/products/${data._id}`}> */}
          {/* <div className="relative group w-full h-[140px] sm:h-[240px] overflow-hidden">
            <img
              src={data.images[0]}
              alt="product"
              className="w-full h-full object-cover object-top duration-200 ease-in"
            /> */}

            {/* Side thumbnail list */}
            {/* <div className="absolute top-0 left-0 hidden group-hover:flex flex-col bg-white bg-opacity-90 p-1 gap-1 z-10 h-full overflow-y-auto">
              {data.images.slice(1).map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt={`thumb-${idx}`}
                  className="w-10 h-10 object-cover border border-gray-200 cursor-pointer hover:border-primary"
                  onMouseEnter={(e) => {
                    e.stopPropagation();
                    const mainImg = e.currentTarget.closest(".group").querySelector("img");
                    if (mainImg) mainImg.src = img;
                  }}
                />
              ))}
            </div>
          </div> */}
        <Link to={`/products/${data._id}`}>
          <div
            className="relative aspect-square overflow-hidden group"
            onMouseEnter={startAutoSlide}
            onMouseLeave={stopAutoSlide}
          >
            <img
              src={currentImage}
              alt="product"
              className="w-full h-full object-cover object-top duration-500 ease-in"
            />

            Dots
            {isHovered && (
              <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex gap-1">
                {data.images.map((_, index) => (
                  <div
                    key={index}
                    className={`w-2 h-2 rounded-full ${
                      currentImageIndex === index ? "bg-primary" : "bg-gray-400"
                    }`}
                  ></div>
                ))}
              </div>
            )}
          </div>


        </Link>

        <div className=" bg-red-600 hover:bg-black cursor-pointer absolute text-[20px] px-2 py-1 rounded-full w-10 text-center flex justify-center items-center h-10 text-white capitalize font-bold right-2 top-5" onClick={()=>handleToWish(data)}>
            <FaRegHeart />
        </div> 
        <span className=" bg-red-600 absolute text-[10px] px-2 py-1 text-white capitalize font-bold left-0 top-5">
          {data.label[0]}
        </span>
      </div>
      <div className=" flex flex-col w-full gap-1 p-2">
        <span className=" text-[12px] text-gray-600">
          {categorys.find((cate) => cate._id === data.category)?.name}
        </span>
        {/* <div className="flex items-center mt-1  text-gray-600">
                {[1, 2, 3, 4, 5].map((index) =>
                  index <= data.rate ? (
                    <FaStar key={index} color="#ffa569" />
                  ) : (
                    <FaRegStar key={index} />
                  )
                )}
              </div> */}
        <h4 className=" text-[12px] md:text-[15px] font-bold hover:text-primary cursor-pointer w-fit">
          <Link to={`/products/${data._id}`}>{data.name.slice(0,20)}</Link>
        </h4>
        <h4 className=" text-[12px] md:text-[15px] font-boldw-fit text-red-600 font-bold">
          {" "}
          &#8377; {data.salePrice}{" "}
          <span className=" line-through text-gray-700 font-normal text-[12px]">
            &#8377; {data.price}
          </span>
        </h4>
      </div>
      {added ? <button className=" px-3 py-1 bg-primary text-white m-2 rounded-md" onClick={()=>navigate('/cart')}>
        Go to cart
      </button> :<button className=" px-3 py-1 bg-primary text-white m-2 rounded-md" onClick={()=>handleAddProduct(data)}>
        Add to cart
      </button>}
    </div>
  );
};

export default WishCard;
